<div
  class="myre-modal-wrapper"
  [class.open]="showBackground"
  [class.has-modal]="hasModals()"
  [style.z-index]="wrapperZIndex()"
>
  @for (modal of modals; track modal; let first = $first) {
    @if (first) {
      <div [@appear] class="background"></div>
    }
    @if (modal.type === 'sidebar') {
      @if (modal.sidebarFrom === 'left') {
        <myre-modal
          [id]="'modal-' + modal.uid"
          [modal]="modal"
          [@appearFromLeft]
          (@appearFromLeft.done)="animationDone()"
        />
      }
      @if (modal.sidebarFrom === 'right') {
        <myre-modal
          [id]="'modal-' + modal.uid"
          [modal]="modal"
          [@appearFromRight]
          (@appearFromRight.done)="animationDone()"
        />
      }
    } @else {
      <myre-modal
        [modal]="modal"
        [id]="'modal-' + modal.uid"
        [@appearFromTop]="modal.hidden ? 'hide' : 'show'"
        (@appearFromTop.start)="animationStart($event)"
        (@appearFromTop.done)="animationDone()"
      />
    }
  }
</div>
